module.exports = __webpack_public_path__ + "static/media/certificate-path-background.8f93a43e.svg";